export const scanImage = (callback) => {
  /* eslint-disable no-undef */

  const DWObject = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer');
  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then((res) => {
        return res.arrayBuffer();
      })
      .then((buf) => {
        return new File([buf], filename, { type: mimeType });
      });
  };
  if (DWObject) {
    DWObject.SelectSource(
      () => {
        DWObject.OpenSource();
        DWObject.IfShowUI = false;
        DWObject.AcquireImage(
          () => {
            DWObject.ConvertToBase64(
              [DWObject.CurrentImageIndexInBuffer],
              1,
              (e) => {
                const base64 = e.getData(0, e.getLength());
                const base64Image = 'data:image/jpeg;base64,' + base64;
                typeof base64 === 'string' &&
                  urltoFile(base64Image, 'scanner.jpeg', 'image/jpeg').then((file) => {
                    callback({
                      base64Image,
                      file,
                    });
                    DWObject.RemoveAllSelectedImages();
                  });
              },
              (e) => {
                // eslint-disable-next-line
                console.log(e);
              }
            );
          },
          () => {
            DWObject.CloseSource();
          }
        );
      },
      () => {
        // eslint-disable-next-line no-console
        console.log('SelectSource failed!');
      }
    );
  }
};
